module.exports = __webpack_public_path__ + "img/Group 769wx.92ba284d.svg";